import React, { useState } from "react";
import { ListMusic, ChevronDown, ChevronUp, Volume2, Play } from "lucide-react";

const fmt = (s) => (s ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}` : "");

export function ZonePlaylist({ zoneId, onAir, playing, color, onPlayTrack }) {
  const [open, setOpen] = useState(false);
  const tracks = onAir?.tracks || [];
  const curIdx = tracks.findIndex((t) => t.file && t.file === onAir?.file);
  const cur = curIdx >= 0 ? tracks[curIdx] : null;
  if (!tracks.length) return null;
  return (
    <div className="border-t border-[#f0e6d8]" data-testid={`music-playlist-${zoneId}`}>
      <button onClick={() => setOpen((o) => !o)} className="w-full px-4 py-2.5 flex items-center gap-2 text-left hover:bg-[#faf3ee] transition-colors" data-testid={`music-playlist-toggle-${zoneId}`}>
        <ListMusic className="h-4 w-4 text-[#7c5a4e] shrink-0" />
        <span className="text-xs font-semibold text-[#4a1c17]">Playlist · {tracks.length} brani</span>
        {cur && playing && <span className="ml-auto text-[11px] text-[#7c5a4e] truncate max-w-[50%]">{curIdx + 1}. {cur.title}</span>}
        {open ? <ChevronUp className="h-4 w-4 text-[#7c5a4e] shrink-0" /> : <ChevronDown className="h-4 w-4 text-[#7c5a4e] shrink-0" />}
      </button>
      {open && (
        <ol className="max-h-72 overflow-y-auto divide-y divide-[#f5ede2]">
          {tracks.map((t, i) => {
            const isCur = i === curIdx && playing;
            return (
              <li key={t.file + i} className={`group px-4 py-1.5 flex items-center gap-2.5 text-sm ${isCur ? "font-semibold" : "text-[#4a3b36]"}`} style={isCur ? { background: `${color || "#8c6b5d"}1a`, color: "#2b1410" } : {}} data-testid={`music-track-${zoneId}-${i}`}>
                <span className="w-5 text-right text-xs tabular-nums shrink-0" style={{ color: isCur ? color || "#4a1c17" : "#a08a7e" }}>
                  {isCur ? <Volume2 className="h-3.5 w-3.5 inline animate-pulse" /> : i + 1}
                </span>
                <span className="truncate flex-1">{t.title}{t.artist && <span className="text-[#8a6e62] font-normal"> · {t.artist}</span>}</span>
                <span className="text-xs tabular-nums text-[#a08a7e] shrink-0">{fmt(t.duration)}</span>
                {onPlayTrack && !isCur && (
                  <button onClick={() => onPlayTrack(t.file)} className="h-7 w-7 rounded-full border border-[#e8dcc8] bg-white text-[#4a1c17] flex items-center justify-center hover:bg-[#4a1c17] hover:text-white shrink-0" title="Suona subito" data-testid={`music-track-play-${zoneId}-${i}`}><Play className="h-3 w-3" /></button>
                )}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
